import React from "react";
import "./Footer.css";

const Footer: React.FC = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="footer">
      <div className="footer-container">
        <p className="footer-company">모멘트업 (Momentup)</p>
        <p className="footer-contact">
          <a href="mailto:momentupcompany@gmail.com">
            momentupcompany@gmail.com
            <br/>
            사업자 등록 번호 526-13-02854
          </a>
        </p>
        <p className="footer-copyright">
          © {currentYear} Momentup. All rights reserved.
        </p>
      </div>
    </footer>
  );
};

export default Footer;
